
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ActionCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  buttonText: string;
  buttonAction: () => void;
  backgroundColor: string;
}

export const ActionCard: React.FC<ActionCardProps> = ({
  icon: Icon,
  title,
  description,
  buttonText,
  buttonAction,
  backgroundColor,
}) => {
  return (
    <Card className={`${backgroundColor} border-none shadow-md h-[320px] flex flex-col`}>
      <CardContent className="text-center pt-6 flex-grow flex flex-col justify-between">
        <div className="mb-4">
          <div className="flex justify-center mb-4">
            <Icon className="h-8 w-8 text-[#00123A]" />
          </div>
          <h3 className="text-2xl font-semibold text-[#00123A] mb-4">{title}</h3>
          <p className="text-lg text-[#00123A]">
            {description}
          </p>
        </div>
        <div className="mt-auto pb-8">
          <Button 
            variant="secondary" 
            className="bg-white text-[#00123A] hover:bg-white/90 font-semibold px-6 py-5 h-auto"
            onClick={buttonAction}
          >
            {buttonText}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
